import { fetchApi } from '@/services/api';
import type {
  SentOrderDetail,
  SentOrdersFiltersResponse,
  SentOrdersListResponse,
  SentOrdersQueryParams,
} from './orders.types';

class OrdersService {
  async getOrders(params: SentOrdersQueryParams): Promise<SentOrdersListResponse> {
    const queryParams: Record<string, string | number | boolean | string[]> = {
      page: params.page ?? 1,
      page_size: params.page_size ?? 10,
      supplier_id: (params.supplierIds ?? []).map((id) => String(id)),
      user_id: (params.userIds ?? []).map((id) => String(id)),
    };

    if (params.dateFrom) queryParams.date_from = params.dateFrom;
    if (params.dateTo) queryParams.date_to = params.dateTo;
    if (typeof params.warehouseId === 'number') queryParams.warehouse_id = params.warehouseId;

    return fetchApi<SentOrdersListResponse>('supply/orders/', {
      params: queryParams,
    });
  }

  async getFilters(warehouseId?: number | null): Promise<SentOrdersFiltersResponse> {
    const queryParams: Record<string, string | number | boolean | string[]> = {};
    if (typeof warehouseId === 'number') queryParams.warehouse_id = warehouseId;
    return fetchApi<SentOrdersFiltersResponse>('supply/orders/filters/', {
      params: queryParams,
    });
  }

  async getOrderDetail(orderId: number): Promise<SentOrderDetail> {
    return fetchApi<SentOrderDetail>(`supply/orders/${orderId}/`);
  }
}

export const ordersService = new OrdersService();
